var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "auto-height",
    { staticClass: "group-message-list-container", attrs: { margin: 8 } },
    [
      _c("common-bulk-message-list", {
        ref: "list",
        staticClass: "list h-100 overflow-auto",
        attrs: { url: _vm.indexUrl },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (slotProps) {
              return [
                _c(
                  "common-bulk-message-list-item",
                  _vm._b(
                    {
                      key: slotProps.item.id,
                      on: {
                        "show-messages": _vm.showMessages,
                        "refresh-list": _vm.refreshList,
                      },
                    },
                    "common-bulk-message-list-item",
                    slotProps,
                    false
                  )
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.shouldDisplaySmsMessageList
        ? _c("sms-message-list", {
            attrs: { "bulk-message": _vm.display.item.bulk_message },
            on: { close: _vm.onClose },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldDisplaySmsMessagePreviewList
        ? _c("schedule-preview-message-list", {
            attrs: { "bulk-message": _vm.display.item.bulk_message },
            on: { close: _vm.onClose },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldDisplayEmailMessageList
        ? _c("EmailMessageList", {
            attrs: {
              "email-bulk-message": _vm.display.item.email_bulk_message,
            },
            on: { close: _vm.onClose },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }